import "styles/plugins.sass";
import "styles/app.sass";
import { ToastContainer } from "react-toastify";
import RouteProvider from "utils/route/Provider";
import { config } from "utils/constants/config";
import UnderMaintenance from "component/layout/UnderMaintenance";

function App() {
    const isUnderMaintenance = config.underMaintenance;

    if(isUnderMaintenance){
        return <UnderMaintenance />
    }else{
        return (
            <>
                <RouteProvider />
                <ToastContainer
                    closeButton={false}
                    hideProgressBar={true}
                    autoClose={3000}
                    position="top-center"
                />
            </>
        );
    }
}

export default App;
